module.exports = __webpack_public_path__ + "media/packs/images/update-icons/change-2242254087e636817857af1afa948d11.svg";